import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';
import type { AuthResponse } from './types';

export const meQueryKey = ['me'] as const;

export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: () => api<AuthResponse>('/api/auth/me'),
    staleTime: 60_000,
    retry: false,
  });
}

export function useSetMe() {
  const qc = useQueryClient();
  return (data: AuthResponse) => qc.setQueryData(meQueryKey, data);
}

export async function logout(): Promise<void> {
  await api('/api/auth/logout', { method: 'POST' });
  location.href = '/';
}
